import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../../core/services/helpers.service';
import { RoutingConfigurationUtilService } from '../../../../core/services/routing-configuration-util.service';
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { NomiDescrittoriSezione } from '../../../configuration/nomi-descrittori-sezione';
import { DescrittoreSezione } from '../../../models/descrittore-sezione';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { DeletePraticaComponent } from '../deletePratica/delete-pratica.component';


@Component({
    selector: 'ul [option-pratica]',
  templateUrl: 'option-pratica.component.html'
})

export class OptionPraticaComponent implements OnInit {
  @Input() pratica: PraticaBase;
  @Input() descrittori: DescrittoreSezione[];
  @Input() location: string;
  @Output() onReturnMethodPraticaOption: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('deletePratica') deletePratica: DeletePraticaComponent;

  private descrittoreDefinizione: boolean;
  private descrittoreRimozioneDefinizione: boolean;
  private descrittoreRiunisciGiudizi: boolean;
  private descrittoreCancellazione: boolean;
  private descrittoreCreazionePratica: boolean;
  private descrittoreCopiaPratica: boolean;
  private descrittoreArchiviazione: boolean;
  private descrittoreRimozioneRiunione: boolean;
  private descrittoreCorrelaPratica: boolean;
  private descrittorePraticaPrecedente: boolean;
  private isViewPraticaView: boolean = true;
  private urlPathViewPratica: string = '';
  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;


  constructor(private route: ActivatedRoute,
              private router: Router,
              private routingService: RoutingConfigurationUtilService,
              private helpersService: HelpersService) { }

  ngOnInit() {
    this.setRoutingVisualizzazionePratica(this.pratica);
//    this.helpersService.getDescrittoriSezione(MenuActions.VISUALIZZA_PRATICA, this.pratica.tipoPratica.id, null).subscribe(
//        response => this.setDescrittorePratica(response));
    if (this.descrittori) {
      for (let descrittore of this.descrittori) {
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_DEFINIZIONE) {
          this.descrittoreDefinizione = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE) {
          this.descrittoreRimozioneDefinizione = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIUNIONE_GIUDIZI) {
          this.descrittoreRiunisciGiudizi = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CANCELLAZIONE) {
          this.descrittoreCancellazione = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CREAZIONE_PRATICA) {
          this.descrittoreCreazionePratica = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_COPIA_PRATICA) {
          this.descrittoreCopiaPratica = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_ARCHIVIAZIONE) {
          this.descrittoreArchiviazione = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE) {
          this.descrittoreRimozioneRiunione = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CORRELA_PRATICA) {
          this.descrittoreCorrelaPratica = descrittore.writable;
        }
        if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CORRELA_PRATICA) {
          this.descrittorePraticaPrecedente = descrittore.writable;
        }
      }
    }
  }

  setRoutingVisualizzazionePratica(pratica: PraticaBase) {
    if (pratica && pratica.tipoPratica) {
      let urlViewPratica = '/' + this.routingService.getRoutingVisualizzazionePraticaModule(pratica.tipoPratica.id) + '/' + this.pratica.id;
      if (urlViewPratica === this.router.url ) {
        this.isViewPraticaView = false;
      }else {
        this.isViewPraticaView = true;
      }
      this.urlPathViewPratica = urlViewPratica;
    }
  }

  onClickOption(method: string, pratica: PraticaBase) {
    this.onReturnMethodPraticaOption.emit({method, pratica});
  }

  onClickDelete(praticaBase: PraticaBase) {
    this.deletePratica.deletePratica(praticaBase);
  }

//  setDescrittorePratica(descrittoriPratica: DescrittoreSezione[]) {
//    for (let descrittore of descrittoriPratica) {
//      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_PRATICA) {
//        this.descrittorePratica = descrittore;
//      }
//    }
//  }
}
